module.exports = __webpack_public_path__ + "img/2.999a594e.png";